import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { getFormattedTime } from 'webapp/utils/number';

import highlightResult from 'webapp/helpers/highlight-result';
import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import type { Args } from 'webapp/components/boards/select/item-base';
import BoardsSelectItemBaseComponent from 'webapp/components/boards/select/item-base';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import TagContainerComponent from 'webapp/components/tag-container';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';
import VerificationBadgeComponent from 'webapp/components/verification/badge';

export default class BoardsSelectGridItemComponent extends BoardsSelectItemBaseComponent<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	get createdDateText(): string {
		return getFormattedTime(
			this.args.model.created,
			this.currentUserService.model?.timezone,
			'D MMM YYYY',
		);
	}
	<template>
		<li
			role="button"
			data-id={{@model.id}}
			class="board flex-item filter-sort-item
				{{@model.animationClass}}
				{{if this.isChecked 'checked'}}"
			{{on "click" (fn this.select @model)}}
		>

			<BoardImagePreviewComponent
				@image={{@model.image}}
				@color={{this.color}}
				@count={{this.boardCount}}
				@model={{@model}}
				@theme={{this.themeId}}
				@isLazyLoaded={{true}}
				@lazyLoadScrollContainer={{this.lazyLoadScrollContainerSelector}}
			/>

			{{#if this.isVisibleOnScreen}}
				<FormCheckboxComponent
					@selected={{this.isChecked}}
					@onBeforeChange={{this.beforeSelect}}
					@onChange={{fn @onSelect @model}}
				/>

				<div class="info">
					<div class="info__title">
						<strong>
							{{#if this.boardFromAnotherSpaceSourceWarning}}
								<ToolTipWithIconComponent
									@text={{this.boardFromAnotherSpaceSourceWarning}}
									@iconName="AlertFill"
									@maxWidth={{300}}
								/>
							{{/if}}
							{{highlightResult text=this.name match=this.activeFilter}}
							<VerificationBadgeComponent
								@verification={{this.verificationInfo}}
								@entityLabel="databoard"
								@size="sm"
							/>
						</strong>
					</div>
					<div class="info__description">
						<span>{{this.createdDateText}}</span>
						{{#unless this.isBoardFromAnotherSpace}}
							<TagContainerComponent
								@model={{this.modelAsBoardOrBoardLoop}}
								@canEdit={{false}}
							/>
						{{/unless}}
					</div>
				</div>
			{{else}}
				<div {{visibleCheckItem this.visibleChanged false}}></div>
			{{/if}}
		</li>
	</template>
}
